import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import getData from './network/index'

import i18n from '@/locales'
import Lang from '@/components/Lang/LangButton'

import './style.css' // global css

Vue.config.productionTip = false
Vue.prototype.$axios = getData
Vue.component('LangButton', Lang)

new Vue({
  router,
  i18n,
  render: h => h(App),

}).$mount('#app')
